import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { socialItemsData } from 'sections/Blog/data';
import styles from 'sections/Blog/components/SectionPosts/Social/Social.module.scss';

const cn = classNames.bind(styles);

const Social = (): ReactElement => {
  const socialElements = socialItemsData.map((item, index) => {
    return (
      <div className={cn('post-card__social')} key={`${item.link}_${index}`}>
        <img src={`/images/global/social/${item.icon}`} alt="DFA social icon" />
        <a href={item.link} target="_blank" rel="noopener noreferrer">
          Subscribe
        </a>
      </div>
    );
  });

  return <li className={cn('post-card', 'no-pointer')}>{socialElements}</li>;
};

export default Social;
